import React, { FunctionComponent } from 'react';
import { ArticleBody } from '../../ArticleBody/ArticleBody';
import { ArticleFooter } from '../../ArticleFooter/ArticleFooter';
import { TemplateProps } from './props/TemplateProps';
import { ArticleHeading } from '../../ArticleHeading/ArticleHeading';
import { AdBackground } from '../../../Ads/AdBackground';
import { GoogleAdDesktop } from '../../../Ads/GoogleAdDesktop';
import {
    ads,
    adsSpecialProject2,
    adsSpecialProject3,
    adsSpecialProjectHeader,
} from '../../../../services/ads/constants';
import { AdsConfig } from '../../ArticleHeading/models/AdsConfig';
import { AdvertisementText } from '../../ArticleBody/Components/AdvertisementText';

export const Template1: FunctionComponent<TemplateProps> = ({ article, body, related }) => {
    const articleHeadingAds: AdsConfig = {
        desktop: {
            ad: adsSpecialProjectHeader,
            isSticky: false,
        },
        mobile: {
            ad: adsSpecialProjectHeader,
            isSticky: false,
        },
    };

    const articleBodyAds: AdsConfig[] = [
        {
            desktop: {
                ad: ads[15],
                isSticky: false,
            },
            mobile: {
                ad: ads[15],
                isSticky: false,
            },
        },
        {
            desktop: {
                ad: ads[16],
                isSticky: false,
            },
            mobile: {
                ad: ads[16],
                isSticky: false,
            },
        },
        {
            desktop: {
                ad: ads[17],
                isSticky: false,
            },
            mobile: {
                ad: ads[17],
                isSticky: false,
            },
        },
    ];

    return (
        <>
            <div className='container d-flex flex-row'>
                <div className='container'>
                    <ArticleHeading adsConfig={articleHeadingAds} article={article} />
                    <ArticleBody body={body} adsConfig={articleBodyAds} />
                    <AdvertisementText article={article} />
                </div>
                <div className='d-none d-md-inline-block d-lg-inline-block mx-2 '>
                    <GoogleAdDesktop ad={adsSpecialProject2} />
                    <AdBackground className='sticky-ad'>
                        <GoogleAdDesktop ad={adsSpecialProject3} />
                    </AdBackground>
                </div>
            </div>
            <div className='container'>
                <ArticleFooter article={article} related={related} />
            </div>
            {/*<MoreFromWomanBG/>*/}
        </>
    );
};
